

export function getYoutubeThumbnail(ytid)
{
    return 'https://img.youtube.com/vi/'+ytid+'/hqdefault.jpg';
}